app.views.account = app.views.base.extend({
  attr: {
    containerId: '#AccountDetails',
    panelClass: '.account',
    link: 'data-link'
  },
  init: function init() {
    this.initSpinners();
  },
  loadAccountSelectorModal: function loadAccountSelectorModal() {
    app.helpers.openModal("/accounts/account-selector", 'ajax');
  },
  showPlanExplorerWarningModal: function showPlanExplorerWarningModal(warningType) {
    app.helpers.openModal("/plan-explorer-warning?warningType=" + warningType, 'ajax');
  },
  recordSuccessfulLogin: function recordSuccessfulLogin(loginType) {
    if (loginType !== "customer" && loginType !== "legacy" && loginType !== "enhanced") {
      console.log("Unable to log successful login. Unknown login type provided: " + loginType);
      return;
    }
    $(window).on("load", function () {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'Login_Success',
        'login': {
          'status': 'Success',
          'type': loginType
        }
      });
    });
  },
  initSpinners: function initSpinners() {
    var _this = this;
    $(_this.attr.containerId).find('[' + this.attr.link + ']').each(function (i) {
      $(this).on('click', function () {
        var panel = $(this).closest(_this.attr.panelClass);
        if (panel) {
          var spinner = $(panel).find('.form-spinner');
          if (spinner) {
            spinner.show();
          }
        }
      });
    });
  }
});